import { useMutation, useQueryClient } from '@tanstack/react-query'

import axios from '@pepper/utils/src/function/axiosInstance'
import extract from '@pepper/utils/src/function/extract'
import { SEO_SERVICE_BASE_URL } from '@pepper/utils/src/api/config'

type Parameters = {
  companyId: string
  projectId: string
  keywords: string[]
}

const addBatchKeywords = async ({
  companyId,
  projectId,
  keywords,
}: Parameters) => {
  try {
    const url = `${SEO_SERVICE_BASE_URL}/companies/${companyId}/keywords/v2/batch`
    const response = await axios.post(url, {
      project_id: projectId,
      keywords,
    })
    return response.data
  } catch (error) {
    return extract.error(error)
  }
}

export const useCreateBulkKeywords = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (params: Parameters) => addBatchKeywords(params),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['project-keywords'],
      })
    },
  })
}
